import {useQuery} from "@tanstack/react-query";
import {ProductExSearchParamType} from "../interface";
import {productExListMapInit} from "../state";
import {readProductByDoubleFilterEx} from "../../../../../api/product/ProductExApi";

type Props = {
    param: ProductExSearchParamType;
};

export const useReadProductByDoubleFilterEx = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readProductByDoubleFilterEx", param],
        queryFn: async () => await readProductByDoubleFilterEx(param),
        select: (res) => res?.data.result ?? productExListMapInit
    });

    return {data};
};
